import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { login, logout } from '../slices/authSlice';
import { LOGIN, LOGIN_VERIFY_OTP, LOGIN_RESEND_OTP, LOGOUT, MASTER_LOGIN } from "config/apiPaths";
import { SSO_URL } from "config/constants";
import apiRegistry from "utils/apiRegistry";

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${SSO_URL}user`,
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: LOGIN,
        method: 'POST',
        data: credentials,
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),
    resendLoginOtp: builder.mutation({
      query: (credentials) => ({ url: LOGIN_RESEND_OTP, method: 'POST', data: credentials }),
      transformResponse: (response) => response.data,
    }),
    verifyLoginOtp: builder.mutation({
      query: (credentials) => ({ url: LOGIN_VERIFY_OTP, method: 'POST', data: credentials }),
      transformResponse: (response) => {
        if (!response.data?.token) {
          throw new Error('Verification did not return a login token. Please log in again.');
        }
        return response.data;
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(login({
            token: data?.token,
            user: {
              firstname: data?.userInfo?.firstname,
              lastname: data?.userInfo?.lastname,
              id: data?.userInfo?.id,
              profile_picture: data?.userInfo?.profile_picture,
              email: data?.userInfo?.email
              // role: data?.userIn
            }
          }));
        } catch (error) {
          console.error('Login failed:', error);
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: LOGOUT,
        method: 'GET',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          apiRegistry.forEach(api => dispatch(api.util.resetApiState()));
          dispatch(logout());
        } catch (error) {
          console.error('Logout failed:', error);
        }
      },
    }),
    masterLogin: builder.mutation({
      query: ({ body }) => ({
        url: MASTER_LOGIN,
        method: 'POST',
        data: body,
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useVerifyLoginOtpMutation,
  useResendLoginOtpMutation,
  useLogoutMutation,
  useMasterLoginMutation
} = authApi;
